import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('GreenPlan Error:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    localStorage.removeItem('greenplan_v4');
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div 
          style={{ 
            minHeight: '100vh',
            background: '#080f09',
            color: '#e8f5e9',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '2rem',
            fontFamily: "'Palatino Linotype', Palatino, serif",
          }}
        >
          <div 
            style={{ 
              textAlign: 'center',
              maxWidth: '400px',
            }}
          >
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🌱</div>
            <h1 
              style={{ 
                fontSize: '1.5rem', 
                fontWeight: 'normal',
                color: '#f0fdf4',
                marginBottom: '0.75rem',
              }}
            >
              Something went wrong
            </h1>
            <p 
              style={{ 
                color: '#6b7280', 
                fontSize: '0.9rem',
                lineHeight: 1.6,
                marginBottom: '1.5rem',
              }}
            >
              GreenPlan encountered an unexpected error. Try refreshing the page or resetting your data.
            </p>
            <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center' }}>
              <button
                onClick={() => window.location.reload()}
                style={{
                  background: '#16a34a',
                  border: 'none',
                  color: '#fff',
                  padding: '0.6rem 1.2rem',
                  borderRadius: '8px',
                  fontSize: '0.85rem',
                  cursor: 'pointer',
                }}
              >
                Refresh Page
              </button>
              <button
                onClick={this.handleReset}
                style={{
                  background: 'rgba(255,255,255,0.1)',
                  border: '1px solid rgba(255,255,255,0.2)',
                  color: '#9ca3af',
                  padding: '0.6rem 1.2rem',
                  borderRadius: '8px',
                  fontSize: '0.85rem',
                  cursor: 'pointer',
                }}
              >
                Reset Data
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
